import { CellContext } from "@tanstack/react-table";
import { useState } from "react";
import { EditAbleCell, StyledTableCellProps } from "./styledTableCell";
// import { SimplifiedInputField } from "../../BaseComponents/SimplifiedInputField";
import { IdentifiableRow } from "../reactiveTableRenderer";
import { FieldTypes, FieldStyles } from "../../../Definitions";
import { InputField } from "../../BaseComponents";

export const StringTableCell = <T extends IdentifiableRow,> ({getValue, row, table, column, canEdit, staticColumn, cell}: CellContext<T, string | undefined> & EditAbleCell) => {
  const initialValue = getValue();

  const [value, setValue] = useState(initialValue);

  const onBlur = () => {
    if (value !==initialValue) {
      table.options.meta?.updateData(row.original.id, column.id, value);
    }
  }


  return <StyledStringCell staticColumn={staticColumn} key={cell.id} keyPass={cell.id+"Input"} onBlur={onBlur} onChange={(e: string) => setValue(e)} canEdit={canEdit} cellData={{value}} />
}


const StyledStringCell = ({onBlur, onChange, canEdit, cellData, keyPass, staticColumn}: StyledTableCellProps & EditAbleCell) => {
  if (canEdit) {
    if (staticColumn) { 
      return (
        <div style={{ ...cellData.style, opacity: 0.5  }} key={keyPass}>
          {String(cellData.value) ?? ''}
        </div>
      );
    } else {
      return <InputField
        keyPass={keyPass}
        context={String(cellData.value)}
        fieldStyle={FieldStyles.greyTertiary}
        fieldType={FieldTypes.editField} 
        // textStart={true} 
        inTable={true}
        inputType="string"
        onChange={onChange}
        onBlur={onBlur}
        key={keyPass}
      />;
    }
  }

  return (cellData.value)

}